import gql from 'graphql-tag';

// Exactly the fields the Daily Boost banner and to-do item render or track.
export const HOME_DAILY_BOOST_QUERY = gql`
  query HomeDailyBoost {
    dailyBoostShort {
      id
      title
      slug
      summary
      html
      isFavourite
      isCompletedToday
      estimatedMins
      cloudinaryThumbnail {
        path
      }
      mediaType {
        value
      }
      exploreCategory {
        id
        internalName
      }
    }
  }
`;
